import ApiService from './api-service'

class Chat extends ApiService {
    constructor() {
        super()

        // this.get = null
        // this.post = null
        this.put = null
        // this.delete = null
    }

    clear(id) {
      if(id) return super.clear(`/chat/${id}`)
      return super.clear('/chat')
    }

    getStats(options) {
      return super.get(`chat/stats`, options)
    }

    listThreads(options) {
      return super.get(`chat`, options)
    }

    get(id, options) {
      return super.get(`chat/${id}`, options)
    }

    // create(payload, options) {
    //   return super.post(`chat`, payload, options)
    // }

    // update(id, payload, options) {
    //   return super.put(`chat/${id}`, payload, options)
    // }

    // delete(id, options) {
    //   return super.delete(`chat/${id}`, options)
    // }

    listMessages(id, options) {
      return super.get(`chat/${id}/message`, options)
    }

    getMessage(id, messageId, options) {
      return super.get(`chat/${id}/message/${messageId}`, options)
    }

    createMessage(id, payload, options) {
      return super.post(`chat/${id}/message`, payload, options)
    }

    updateMessage(id, messageId, payload, options) {
      return super.put(`chat/${id}/message/${messageId}`, payload, options)
    }

    deleteMessage(id, messageId, options) {
      return super.delete(`chat/${id}/message/${messageId}`, options)
    }

    createMessageReply(id, messageId, payload, options) {
      return super.post(`chat/${id}/message/${messageId}/reply`, payload, options)
    }

    addMessageView(id, messageId, options) {
      return super.post(`chat/${id}/message/${messageId}/view`, {}, options)
    }

    createMessageReaction(id, messageId, payload, options) {
      return super.post(`chat/${id}/message/${messageId}/react`, payload, options)
    }

    deleteMessageReaction(id, messageId, options) {
      return super.delete(`chat/${id}/message/${messageId}/react`, options)
    }

    typingMessage(id, options) {
      return super.post(`chat/${id}/message/typing`, {}, options)
    }
}

const _Chat = new Chat()
export default _Chat
